import { AlertType } from '../../../elements/alertPanel/types';
import { CoreContents } from '../../../types';
import { ContentFactory } from './base';

export type AlertPanelOptions = {
  type: AlertType;
  message: string;
};

export class AlertPanelFactory extends ContentFactory {
  constructor(options: AlertPanelOptions) {
    const { type, message } = options;

    super(CoreContents.alertPanel, {
      instructions: {
        type: {
          type: 'StringInstruction',
          instruction: type,
        },
        message: {
          type: 'StringInstruction',
          instruction: message,
        },
      },
    });
  }
}
